"use client";

import React from "react";
import svgPaths from "@/assets/svg/svg-5s97axwnwx";

export default function MobileHowItWorks() {
	return (
		<div className="mb-8">
			<h2 className="text-white text-2xl mb-8">How it Works?</h2>

			<div className="flex flex-col gap-4">
				{/* Step 1 - Discover */}
				<div className="backdrop-blur-md bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-3xl p-4 flex items-start gap-4">
					<div className="w-14 h-14 rounded-full border border-white/10 bg-[#16251c] backdrop-blur-md flex items-center justify-center shrink-0">
						<svg
							className="w-8 h-8"
							fill="none"
							viewBox="0 0 26 26"
						>
							<circle
								cx="11.397"
								cy="11.397"
								r="11.397"
								fill="#25BC45"
							/>
							<path
								d={svgPaths.p27373500}
								stroke="#25BC45"
								strokeLinecap="round"
								strokeWidth="2"
							/>
						</svg>
					</div>
					<div className="flex-1 min-w-0">
						<h3 className="text-white font-black text-base mb-1">
							Discover
						</h3>
						<p className="text-[rgba(255,255,255,0.7)] text-xs leading-relaxed">
							Instantly search our comprehensive tax lien property
							database with advanced filters to find opportunities
							that match your investment goals.
						</p>
					</div>
				</div>

				{/* Step 2 - Evaluate */}
				<div className="backdrop-blur-md bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-3xl p-4 flex items-start gap-4">
					<div className="w-14 h-14 rounded-full border border-white/10 bg-[#16251c] backdrop-blur-md flex items-center justify-center shrink-0">
						<svg
							className="w-7 h-7"
							fill="none"
							viewBox="0 0 24 24"
						>
							<rect
								x="16"
								y="16"
								width="4.8"
								height="8"
								rx="0.96"
								fill="#25BC45"
							/>
							<rect
								x="9.6"
								y="10.8"
								width="4.8"
								height="13.2"
								rx="0.96"
								fill="#25BC45"
							/>
							<rect
								x="3.2"
								y="5.6"
								width="4.8"
								height="18.4"
								rx="0.96"
								fill="#25BC45"
							/>
						</svg>
					</div>
					<div className="flex-1 min-w-0">
						<h3 className="text-white font-black text-base mb-1">
							Evaluate
						</h3>
						<p className="text-[rgba(255,255,255,0.7)] text-xs leading-relaxed">
							Access detailed financial and legal information—debt
							amounts, case numbers, property values, and owner
							information—all in one easy-to-use dashboard.
						</p>
					</div>
				</div>

				{/* Step 3 - Invest */}
				<div className="backdrop-blur-md bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-3xl p-4 flex items-start gap-4">
					<div className="w-14 h-14 rounded-full border border-white/10 bg-[#16251c] backdrop-blur-md flex items-center justify-center shrink-0">
						<svg
							className="w-8 h-8"
							fill="none"
							viewBox="0 0 24 24"
						>
							<path
								d="M3 17L9 11L13 15L21 7M21 7H15M21 7V13"
								stroke="#25BC45"
								strokeWidth="2.5"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					</div>
					<div className="flex-1 min-w-0">
						<h3 className="text-white font-black text-base mb-1">
							Invest
						</h3>
						<p className="text-[rgba(255,255,255,0.7)] text-xs leading-relaxed">
							Make confident investment decisions using verified
							data, connect with property owners, coordinate with
							legal experts, and secure your next tax lien
							investment.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}
